import(/* webpackMode: "eager", webpackExports: ["FactionFeudTable"] */ "/app/apps/web/src/components/leaderboard/faction-feud-table.tsx");
